define('boxes/helpers/formValidation',['jquery', 'all/jquery/jquery.validate', 'boxes/helpers/tooltip', 'boxes/events/feeEvent'], function ($, validate, toolTip, feeEvent) {
	'use strict';

	var ERROR_CLASS = 'has-error';
	var VALID_CLASS = 'is-valid';
	var INFO_MESSAGE_DATA_ATTRIBUTE = 'content-info';

	var $currentForm;
	var feeData = {};

	var paymentsInstanceReference;

	function customEmailValidation(value) {
		return /^[_A-Za-z0-9-\+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/.test(value);
	}

	function customFeeAmountValidation(value) {
		return feeData.min <= parseFloat(value) && feeData.max >= parseFloat(value);
	}

	function customCreditCardValidation(value, element) {
		var $playerCardId = $currentForm.find('[name="cid"]');
		var playerCardId = $playerCardId.val();
		var valid;
		if (playerCardId && playerCardId !== '-1' && !isNaN(parseInt(playerCardId, 10))) {
			valid = true;
		} else {
			valid = $.validator.methods.creditcard.call(this, value, element);
			if (valid) {
				feeEvent.updateFee(paymentsInstanceReference);
			}
		}

		return valid;
	}

	function getWordCount(wordString) {
		var words = wordString.split(' ');
		var filteredWords = words.filter(function (word) {
			// Just check that the length of the word is greater than 1 and that some numbers and characters is not part of the name
			return (word.length > 0) && (word.search(/[0-9\r\n]/) === -1);
		});
		return filteredWords.length;
	}

	function customWordCountValidation(value, element, numberOfWordsMin) {
		var count = getWordCount(value);
		if (count >= numberOfWordsMin) {
			return true;
		}
	}

	function customOnlyDigitsValidation(value, element) {
		return $.validator.methods.digits.call(this, value, element);
	}

	function getCharacterCount(wordString) {
		return wordString.replace(/ /g, '').length;
	}

	function customCharacterCountValidation(value, element, exactNumberOfCharacters) {
		var count = getCharacterCount(value);
		return count === exactNumberOfCharacters;
	}

	function customExpirationDateValidation() {
		var $expirationDateDiv,
			$expirationMonth,
			expirationMonth,
			$expirationYear,
			expirationYear,
			markAsValid;

		function cssValidationEffects(validityFlag, elements) {
			var length = elements.length,
				i = 0,
				element;

			for (; i < length; i++) {
				element = elements[i];
				if (validityFlag) {
					element.removeClass(ERROR_CLASS);
					element.addClass(VALID_CLASS);
				} else {
					element.addClass(ERROR_CLASS);
					element.removeClass(VALID_CLASS);
				}
			}
		}

		function shouldDateBeMarkedAsValid(expirationMonth, expirationYear) {
			var currentYear = new Date().getFullYear(),
				currentMonth = new Date().getMonth() + 1;

			return isNaN(expirationMonth) ||
				isNaN(expirationYear) ||
				(expirationYear > currentYear) ||
				((expirationYear === currentYear) && (expirationMonth >= currentMonth));
		}

		$expirationDateDiv = $currentForm.find('#expirationDate');

		$expirationMonth = $expirationDateDiv.find('[name="card-month"]');
		expirationMonth = Number($expirationMonth.find('select option:selected').text());

		$expirationYear = $expirationDateDiv.find('[name="card-year"]');
		expirationYear = Number($expirationYear.find('select option:selected').text());

		markAsValid = shouldDateBeMarkedAsValid(expirationMonth, expirationYear);
		cssValidationEffects(markAsValid, [$expirationMonth, $expirationYear]);
		return markAsValid;
	}

	function addValidationCustomRules() {
		resetCssValidationEffect();
		$.validator.addMethod('customEmail', customEmailValidation);
		$.validator.addMethod('customFeeAmount', customFeeAmountValidation, feeData.tooltipText);
		$.validator.addMethod('customCreditCard', customCreditCardValidation);
		$.validator.addMethod('customWordCount', customWordCountValidation);
		$.validator.addMethod('customOnlyDigits', customOnlyDigitsValidation);
		$.validator.addMethod('customCharacterCount', customCharacterCountValidation);
		$.validator.addMethod('customExpirationDate', customExpirationDateValidation);
	}

	function highlight(element, errorClass, validClass) {
		var $input = $(element);
		var $inputParent = $input.parent();
		$inputParent.addClass(errorClass).removeClass(validClass);
	}

	function unHighlight(element, errorClass, validClass) {
		var $input = $(element);
		var $inputParent = $input.parent();
		$inputParent.removeClass(errorClass).addClass(validClass);
		$inputParent.popover('destroy');
	}

	function errorPlacement(error, element) {
		$('.popover').hide();
		var $element = $(element).parent();
		toolTip.showError($element, $(error).text());
	}

	function setupValidation($form, $elements, paymentsInstance) {
		$currentForm = $form;


		paymentsInstanceReference = paymentsInstance;

		addValidationCustomRules();
		var validationConfiguration = {
			errorClass: ERROR_CLASS,
			validClass: VALID_CLASS,
			onkeyup: false,
			rules: {
				stored: {
					required: false
				},
				amount: {
					required: true,
					customFeeAmount: true
				},
				// Yann: The following variable names... Seriously? You don't need to minify/uglify JS code yourself
				// Mattias response: Seriously, why don't you change the names yourself then? Just make sure that the code still works afterwards...
				cn: {
					required: true,
					customCreditCard: true
				},
				co: {
					required: true,
					customWordCount: 2
				},
				cc: {
					required: true,
					customOnlyDigits: true,
					customCharacterCount: 3
				},
				vm: {
					required: true,
					customExpirationDate: true
				},
				vy: {
					required: true,
					customExpirationDate: true
				}
			},
			messages: {
				vm: {
					required: 'Please select a template'
				}
			},
			highlight: highlight,
			unhighlight: unHighlight,
			errorPlacement: errorPlacement
		};

		$form.on('invalid-form', function() {
			$(this).find('button').prop('disabled', false);
		});

		$form.validate(validationConfiguration);

		addClassRules($elements.find('.validate-email'), {
			required: true,
			email: true,
			customEmail: true
		});
	}

	function addClassRules($elements, rulesData) {
		if ($elements.length < 1) {
			return;
		}
		$elements.rules('add', rulesData);
	}

	function setupFocusPopover($elements) {
		$elements.find('input, select, textarea').off('focus').focus(function () {
			$('.popover').hide();
			var $inputElement = $(this).parent();
			if ($inputElement.hasClass(ERROR_CLASS)) {
				toolTip.showError($inputElement);
			} else {
				toolTip.showPopover($inputElement, $inputElement.data(INFO_MESSAGE_DATA_ATTRIBUTE));
			}
		});
	}

	function updateTooltipAmount(data, paymentsInstance) {
		var $amountBox = $currentForm.find('.amount-box');
		var max = parseFloat(data.PARAM_MAX_OPERATION);
		var min = parseFloat(data.PARAM_MIN_OPERATION);

		var $tooltipMin = paymentsInstance.$box.find('.tooltipMin');
		var $tooltipMax = paymentsInstance.$box.find('.tooltipMax');
		var $tooltipMessage = paymentsInstance.$box.find('.tooltipMessage');
		var $tooltipResponsible = paymentsInstance.$box.find('.tooltipResponsibleGaming');
		var tooltipText;
		if(max === 0){
			var responsibleGamingLimit = parseFloat(data.PARAM_RESPONSIBLE_GAMING_LIMIT) ;
			tooltipText = '<p>' + $tooltipMax.html() + ' 0 ' + $tooltipResponsible.html() + '</p>';
		}else{
			tooltipText = '<p>' + $tooltipMessage.html() + '</p>' +
				'<p>' + $tooltipMin.html() + ' ' + min + ' ' + data.PARAM_CURRENCY_ISO + '</p>' +
				'<p>' + $tooltipMax.html() + ' ' + max + ' ' + data.PARAM_CURRENCY_ISO + '</p>';
		}

		$amountBox.data().contentError = tooltipText;

		feeData = {min: min, max: max, amount: data.PARAM_AMOUNT, tooltipText: tooltipText};
		cssAmountValidateEffect(feeData, $amountBox);
	}

	function updateFeeOver(data, paymentsInstance) {
		var $amountBox = $currentForm.find('.amount-box');
		var feeLimit = parseFloat(data.PARAM_FEE_LIMIT);
		var feeText;
		//I know, bad but it is how the old code tells us to not show the fee limit information...
		if (feeLimit > 0) {
			var $tooltipInformation = paymentsInstance.$box.find('.tooltipInformation');
			feeText = $tooltipInformation.html() + ' ' + feeLimit;
		} else {
			feeText = '';
		}
		$amountBox.data().contentInfo = feeText;
	}

	function cssAmountValidateEffect(data, $amountBox) {
		if (data.min > data.amount || data.max < data.amount) {
			$amountBox.addClass(ERROR_CLASS).removeClass(VALID_CLASS);
			toolTip.showPopover($amountBox, data.tooltipText);
		} else {
			$amountBox.removeClass(ERROR_CLASS).addClass(VALID_CLASS);
			toolTip.hidePopover($amountBox);
		}
	}

	function resetCssValidationEffect() {
		var $amountBox = $currentForm.find('.amount-box');
		$amountBox.removeClass(ERROR_CLASS).addClass(VALID_CLASS);
	}

	return {
		valid: function () {
			return $currentForm.valid();
		},
		updateFeeOver: function (feeData, paymentsInstance) {
			updateFeeOver(feeData, paymentsInstance);
		},
		updateFeeTooltip: function (feeData, paymentsInstance) {
			updateTooltipAmount(feeData, paymentsInstance);
		},
		setupFocusPopover: function ($elements) {
			setupFocusPopover($elements);
		},
		setupValidation: function ($form, $validationElements, paymentsInstance) {
			setupValidation($form, $validationElements, paymentsInstance);
		}
	};
});


